import { Utils } from "./Utils";

import * as THREE from "three";

export class MaterialManager {
	static TEX_COLOR = 0x01;
	static TEX_NORMAL = 0x02;
	static TEX_SPECULAR = 0x04;
	static TEX_AO = 0x08;

	protected appContext: any;
	protected autoExt: any;
	protected autoText: any;
	protected materials: { [id:string]:THREE.Material } = {};

	constructor(app3D, options) {
		let opts = new Utils.Options(options);
		this.appContext = app3D;
		this.autoExt = opts.get('autoExt', 'jpeg');
		this.autoText = opts.get('texAuto', 0);  // global auto-loaded textures
	};

	load(id, options) {
		if (this.materials.hasOwnProperty(id))
			return this.materials[id];

		// var man = this;
		// var app = this.appContext;
		let params = {} as any;
		let opts = new Utils.Options(options);
		let color = opts.get('color', null);
		if (color)
			params['color'] = color;

		params['metalness'] = 0.1;

		/*
		let autoText = opts.get('texAuto', 0);
		if (!autoText)
			autoText = this.autoText;

		// load available material maps
		$.each({
			metalnessMap: {name: 'texSpecular', suffix: 'ao', flag: MaterialManager.TEX_SPECULAR},
			aoMap: {name: 'texAO', suffix: 'ao', flag: MaterialManager.TEX_AO}
		}, function (map, m) {
			// noinspection JSBitwiseOperatorUsage
			var tex = app.getTexture((autoText & m.flag)
					? id + '-' + m.suffix + '.' + man.autoExt
					: opts.get(m.name, null));
			// console.log(img);
			if (tex)
				params[map] = tex;
		});*/
		params['aoMapIntensity'] = 10;

		this.materials[id] = new THREE.MeshStandardMaterial(params);
		return this.materials[id];
	};

	get(id:string): THREE.Material {
		return this.materials.hasOwnProperty(id) ? this.materials[id] : null;
	};
}



// WEBPACK FOOTER //
// ./src/script/app3D/Material.ts